module.exports = __webpack_public_path__ + "img/04_bg.a860eebf.png";